module.exports = __webpack_public_path__ + "static/MacBook-Sketch-Wiki-35cc20952e7ad83dd3de2e848deaf01c.png";